import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router";
import { MediaService } from "../../services/mediaService";
import { ucFirst } from "../../utils/ucfirst";
import MediaGallery from "../commons/mediaGallery/mediaGallery";
import type { Media } from "../../interfaces/media";

export function MediaList() {

  const location = useLocation();
  const prefixLocation = ucFirst(location.pathname.split("/")[1]);
  const mediaService = MediaService();
  const [category, setCategory] = useState<any>(null);
  const [medias, setMedias] = useState<Media[]>([]);
  const params = useParams();
  const lang  = params.lang;
  const [slug,setSlug]  = useState(params.slug);

  useEffect(() => {
    const baseSlug = slug ? slug.split('-')[0] : "";
    const expectedSlug = `${baseSlug}-${lang}`;
    const urlParsed:any = location.pathname.split('/');
    urlParsed[1] = lang;
    setSlug(expectedSlug);

  }, [lang]);



useEffect(() => {
  const fetchLang = async () => {
   const res = await mediaService.getAllCategories();
    let selectedCat = res.data.find((item: any) => item.slug === slug);
      if (selectedCat) {

        setCategory(selectedCat);

        try {
          const mediaRes: any = await mediaService.getAll(selectedCat.id);
          if (!mediaRes.data) return;
          const uniqueList = mediaRes.data.map((media: any) => ({
            id: media.id,
            original: media.url,
            thumbnail: media.sizes?.medium?.url,
            width: media.width || 0,
            height: media.height || 0,
            description: media.description || "",
          }));
          setMedias(uniqueList);
        } catch (error) {
          console.error("Erreur lors de la récupération des médias :", error);
        }
      }
  };

  fetchLang();
}, [slug]);


  if (!lang || !category) return <p>Chargement...</p>;

  return (
    <>
      <div className="content-container">
        <h1>{category.name}</h1>
        <div className="padding-15-0">
          {prefixLocation} / {category.name}
        </div>
        <MediaGallery key={category.id + lang} list={medias} />
      </div>
    </>
  );
}


